/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React from "react";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  Typography,
  makeStyles,
} from "@material-ui/core";

const useStyle = makeStyles(() => ({
  infoHeader: {
    fontSize: 20,
    fontWeight: "bold",
    color: "#001fff",
  },
  errorHeader: {
    fontSize: 20,
    fontWeight: "bold",
    color: "black",
  },
  message: {
    fontSize: "1.2em",
    // fontWeight: 'bold',
    padding: 20,
    // margin: '0px 80px',
  },
  buttonContainer: {
    display: "flex",
    justifyContent: "flex-end",
  },
  button: {
    marginTop: "1%",
    color: "green",
    fontWeight: "bold",
    marginRight: -10,
  },
}));

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

function SnackBar({ openDialog, message, onclose, severity }) {
  const classes = useStyle();

  const handleClose = () => {
    onclose();
  };

  return (
    <Box>
      {severity === "success" ? (
        <Snackbar
          a
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          open={openDialog}
          autoHideDuration={2000}
          onClose={handleClose}
        >
          <Alert severity={severity}>{message}</Alert>
        </Snackbar>
      ) : (
        <Dialog open={openDialog}>
          <DialogContent>
            <Typography
              className={
                severity === "info" ? classes.infoHeader : classes.errorHeader
              }
            >
              {severity === "info" ? "Info" : "Error"}
            </Typography>
            <Typography className={classes.message}>{message}</Typography>
            <Box className={classes.buttonContainer}>
              <Button onClick={handleClose} color="secondary">
                Close
              </Button>
            </Box>
          </DialogContent>
        </Dialog>
      )}
    </Box>
  );
}

export default SnackBar;
